import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App.tsx';
import './index.css';
import { logEnvironmentInfo, validateEnvironment } from './lib/env-config';
import { persistor, store } from './store';

// Initialize environment configuration
const envValidation = validateEnvironment();
if (!envValidation.valid) {
  console.error('❌ Environment validation failed:', envValidation.errors);
  throw new Error(
    `Environment validation failed: ${envValidation.errors.join(', ')}`
  );
}

// Log environment information in development
logEnvironmentInfo();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
